import { useForm, FormProvider } from "react-hook-form";
import type { SourceFile } from "../sources-types";
import { FTPInput } from "../../../../../components-new";
import { formSubtitleClass, linkInputSx } from "./addSourceStyles";
import { useSourceForm } from "./useSourceForm";
import { SourceFormFooter } from "./SourceFormFooter";

type AddLinkFormValues = { url: string; name: string };

interface AddLinkFormProps {
  parentId: string | null;
  editNode?: SourceFile | null;
  onSuccess: () => void;
  onCancel: () => void;
}

export default function AddLinkForm({ parentId, editNode, onSuccess, onCancel }: AddLinkFormProps) {
  const { isEdit, submitSource, updateNodeFields } = useSourceForm(parentId, editNode ?? null, onSuccess);

  const methods = useForm<AddLinkFormValues>({
    defaultValues: { url: editNode?.url ?? "", name: editNode?.name ?? "" },
  });

  const onSubmit = async (data: AddLinkFormValues) => {
    const name = data.name?.trim() || "New link";
    const url = data.url?.trim();
    if (isEdit) {
      await updateNodeFields({ name, url });
      return;
    }
    await submitSource({ type: "link", name, more: url ? { url } : {} });
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <h3 className={formSubtitleClass}>{isEdit ? "Edit Link" : "Add Link"}</h3>
        <p className="body2 text-secondary mb-3">Social media, Web, News Links</p>
        <div className="mb-4 space-y-3">
          <FTPInput name="url" label="Paste the link" sx={linkInputSx} size="small" />
          <FTPInput name="name" label="Name this Link" sx={linkInputSx} size="small" />
        </div>
        <SourceFormFooter onCancel={onCancel} submitLabel={isEdit ? "Save" : "Done"} />
      </form>
    </FormProvider>
  );
}
